import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import "../../../styles/Auth/subCategory.css";
import {
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TableContainer,
    Paper,
    Typography,
    Tooltip, Menu, MenuItem
} from '@mui/material';
import { Box, Modal, Button } from '@mui/material';
import { Icon } from "@iconify/react";
import plusIcon from '@iconify/icons-mdi/eye-circle-outline';
import editIcon from '@iconify/icons-mdi/square-edit-outline';
import deleteIcon from '@iconify/icons-mdi/trash-can-outline';
import { postData, uploadFile, getData, putData, deleteData } from "../../../webService/webservice";
import closeIcon from '@iconify/icons-mdi/close-circle-outline';
import ViewsubCategoryPopup from './subCategoryPopup.jsx';
import { toast } from "react-toastify";
import TVFMLoader from "../Loader/loader.jsx";
import { useStore } from "../../../Context/context.jsx";
import AddStoreForm from "../store/AddStoreForm.jsx";
import StoreMultiSelect from "../../Challange/storeMultiSelect.jsx";
import CategorySelect from "../../Challange/CategorySelect.jsx";
import AddCategoryForm from "../Category/AddCategoryForm.jsx";
import StoreSingleAllStoresSelect, { ALL_STORE_OPTION } from "../../Challange/StoreSingleAllStoresSelect.jsx";
import Footer from "../Footer/Footer-page.jsx";
import StockImagePicker from "../../../components/Common/ImagePicker/StockImagePicker.jsx";
const SubCategoryPage = () => {
    const EMPTY_ARRAY = [];
    const navigate = useNavigate();
    const location = useLocation();
    const isAddPage = location.pathname === '/products/sub-category/add';
    const role = localStorage.getItem("role");
    const adminStoreIds = JSON.parse(localStorage.getItem("storeIds") || "[]");
    const [store, setStore] = useState(ALL_STORE_OPTION);
    const initialStoreId = (role === "SuperAdmin" || role === "SelfAdmin") ? store?.value : (adminStoreIds[0] || "");
    const commonCellStyle = {
        color: '#525252',
        fontSize: '12px',
        fontWeight: 600,
        display: "flex",
        alignItems: 'center',
        justifyContent: "center"
    };
    const headings = [
        'S.NO',
        'Image',
        'Category Name',
        'SubCategory Name',
        'Action',
    ];
    const [searchTerm, setSearchTerm] = useState('');
    const [subcategoryImage, setsubCategoryImage] = useState(null);
    const [refreshKey, setRefreshKey] = useState(0);
    const [loading, setLoading] = useState(false);
    const [stores, setStores] = useState([]);
    const [previewUrl, setPreviewUrl] = useState(null);
    const [categories, setCategories] = useState([]);
    const [subcategories, setsubcategories] = useState([]);
    const [viewsubCategoryData, setViewsubCategoryData] = useState(null);
    const [limit, setLimit] = useState(5);
    const [searchQuery, setSearchQuery] = useState('');
    const [openViewPopup, setOpenViewPopup] = useState(false);
    const sessionToken = localStorage.getItem("Token");
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [open, setOpen] = useState(false);
    const [isPopupMode, setIsPopupMode] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [editsubCategoryId, setEditsubCategoryId] = useState(null);
    const [subcategoryToDelete, setsubCategoryToDelete] = useState(null);
    const { selectedStoreId, setSelectedStoreId } = useStore();
    const [errors, setErrors] = useState({});
    const [sortField, setSortField] = useState("createdAt");
    const [sortOrder, setSortOrder] = useState(-1);
    const [isAddStore, setIsAddStore] = useState(false);
    const [isAddCategory, setIsAddCategory] = useState(false);
    const [categoryRefreshKey, setCategoryRefreshKey] = useState(0);
    const sort = [[sortField, sortOrder]];

    const handleSort = (field) => {
        const newOrder =
            sortField === field ? (sortOrder === 1 ? -1 : 1) : -1;

        setSortField(field);
        setSortOrder(newOrder);
    };
    const [showLoader, setShowLoader] = useState(false);
    const [loaderText, setLoaderText] = useState('');
    const [uploadMethod, setUploadMethod] = useState("Normal");
    const [showStockPicker, setShowStockPicker] = useState(false);
    const [selectedStockImage, setSelectedStockImage] = useState(null);
    const wait = (ms) => new Promise(resolve => setTimeout(resolve, ms));

    const fileInputRef = React.useRef(null);
    const [actionAnchorEl, setActionAnchorEl] = useState(null);
    const isActionMenuOpen = Boolean(actionAnchorEl);
    const handleActionClick = (e) => setActionAnchorEl(e.currentTarget);
    const handleActionClose = () => setActionAnchorEl(null);

    const handleBulkUploadClick = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        try {
            const token = localStorage.getItem("Token");
            const userId = localStorage.getItem("userId");

            const sid = (role === "SuperAdmin" || role === "SelfAdmin")
                ? store?.value
                : (Array.isArray(selectedStoreId) ? selectedStoreId[0] : selectedStoreId);

            const storeIdToUse = sid || (stores?.length === 1 ? stores[0]._id : null);

            if (!storeIdToUse) {
                alert("Please select a store before uploading subcategories");
                return;
            }

            const formData = new FormData();
            formData.append("file", file);
            formData.append("storeIds", storeIdToUse);

            const response = await postData(
                `/subcategories/bulkupload/${userId}`,
                formData,
                token,
                true
            );

            if (response?.success === false) {
                alert(response.message || "Bulk Upload Failed!");
            } else {
                alert("Bulk SubCategory Upload Successful!");
                setRefreshKey(prev => prev + 1);
            }
        } catch (error) {
            console.error("Bulk SubCategory Upload Failed:", error);
            alert(error?.response?.data?.message || "Error uploading file!");
        } finally {
            if (e.target) e.target.value = "";
        }
    };

    const handleDownloadSampleTemplate = async () => {
        const token = localStorage.getItem("Token");
        const sid = (role === "SuperAdmin" || role === "SelfAdmin")
            ? store?.value
            : (Array.isArray(selectedStoreId) ? selectedStoreId[0] : selectedStoreId);

        const storeIdToUse = sid || (stores?.length === 1 ? stores[0]._id : null);

        if (!storeIdToUse) {
            alert("Please select a store before downloading the sample template");
            return;
        }

        try {
            const baseUrl = (process.env.REACT_APP_API_URL || "").replace(/\/+$/, "");
            const response = await fetch(`${baseUrl}/subcategories/sample-template/${storeIdToUse}`, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            });

            if (!response.ok) {
                throw new Error("Failed to download template");
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = "SubCategories.xlsx";
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Failed to generate sample template:", error);
            alert("Failed to generate sample template. Please try again.");
        }
    };

    const [formData, setFormData] = useState({
        storeId: initialStoreId,
        storeName: "", // Initialize storeName
        categoryId: '',
        categoryName: '',
        subCategoryName: '',
        subCategoryImageObject: '',
    });

    useEffect(() => {
        const fetchStoreName = async () => {
            if (formData.storeId && !formData.storeName) {
                try {
                    const res = await getData(`stores/store/${formData.storeId}`, {}, sessionToken);
                    if (res?.data) {
                        setFormData(prev => ({
                            ...prev,
                            storeName: res.data.storeName
                        }));
                    }
                } catch (err) {
                    console.error("Failed to fetch store name", err);
                }
            }
        };
        fetchStoreName();
    }, [formData.storeId, formData.storeName]);

    useEffect(() => {
        if (!isPopupMode && (role === "SuperAdmin" || role === "SelfAdmin") && store?.value && !formData.storeId) {
            setFormData(prev => ({
                ...prev,
                storeId: store.value,
                storeName: store.label
            }));
        }
    }, [isPopupMode, store, role]);

    const loadCategories = async (inputValue, loadedOptions, { page }) => {
        try {
            const params = {
                page,
                limit: 10,
                search: inputValue,
                storeId: formData.storeId || (Array.isArray(selectedStoreId) ? selectedStoreId[0] : selectedStoreId)
            };
            const token = localStorage.getItem("Token");
            const res = await getData('categories/categories', params, token);

            const results = res?.data?.results?.[0]?.paginatedResults || [];
            const options = results.map(cat => ({
                value: cat._id,
                label: cat.categoryName
            }));

            return {
                options,
                hasMore: results.length === 10,
                additional: { page: page + 1 }
            };
        } catch (err) {
            console.error("Category Fetch Failed", err);
            return { options: [], hasMore: false };
        }
    };

    const handleAddSubCategory = async (e) => {
        e.preventDefault();

        const validationErrors = validateFields(formData, uploadMethod, subcategoryImage, selectedStockImage);
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        setErrors({});
        setShowLoader(true);

        try {
            const token = localStorage.getItem("Token");
            const userId = localStorage.getItem("userId");

            let finalImageObject = null;

            // ✅ NORMAL UPLOAD
            if (uploadMethod === "Normal") {
                if (subcategoryImage && userId) {
                    const uploadResult = await uploadFile(`files/upload/${userId}`, subcategoryImage);

                    if (uploadResult?.status === 200 || uploadResult?.success) {
                        finalImageObject = uploadResult.data;
                    } else {
                        toast.error(uploadResult?.message || "Image upload failed");
                        setShowLoader(false);
                        return;
                    }
                }
            }

            // ✅ STOCK IMAGE
            else {
                finalImageObject = selectedStockImage;
            }



            const subCategoryData = {
                storeId: formData.storeId,
                categoryId: formData.categoryId,
                subCategoryName: formData.subCategoryName,
                subCategoryImageObject: finalImageObject,

                // ✅ NOW WORKS CORRECTLY
                imageSource: uploadMethod === "Stock" ? "Stock" : "Upload"
            };

            console.log("FINAL PAYLOAD 👉", JSON.stringify(subCategoryData, null, 2));

            const response = await postData("subcategories/", subCategoryData, token);

            toast.success(response.message || "Sub Category added successfully");

            setFormData(prev => ({
                ...prev,
                subCategoryName: "",
                categoryId: "",
                categoryName: "",
                subCategoryImageObject: ""
            }));

            setsubCategoryImage(null);
            setSelectedStockImage(null);
            setPreviewUrl(null);
            triggerRefresh();
            navigate("/products/sub-category")

        } catch (error) {
            console.error("Add SubCategory Error:", error);
            toast.error(error.message || "Add SubCategory Failed");
        } finally {
            setShowLoader(false);
        }
    };


    // Fetch categories whenever page, limit, searchQuery, or selectedStoreId changes
    useEffect(() => {
        const fetchSubCategories = async () => {
            try {
                const params = {
                    page: currentPage,
                    limit: limit === "all" ? 999999 : limit,
                    subCategoryName: searchQuery?.trim() || "",
                    sort: JSON.stringify([[sortField, sortOrder]])
                };
                const sid = role === "SuperAdmin" || role === "SelfAdmin" ? store?.value : Array.isArray(selectedStoreId)
                    ? selectedStoreId[0]
                    : selectedStoreId;
                if (sid && sid.length === 24) {
                    params.storeId = sid;
                }
                // if (selectedStoreId) params.storeId = selectedStoreId;
                const data = await getData('subcategories/subcategories', params, sessionToken);
                if (data?.status !== 200) {
                    toast.error(data?.message || "Failed to fetch subcategories");
                    return;
                }
                const results = data?.data?.results?.[0]?.paginatedResults || [];
                setsubcategories(results);
                setTotalPages(data?.data?.results?.[0]?.totalPages || 1);
                setTotalCount(data?.data?.results?.[0]?.totalCount || 0);
            } catch (error) {
                toast.error(error.message || "Failed to fetch subcategories");
            }
        };
        fetchSubCategories();
    }, [currentPage, limit, refreshKey, searchQuery, selectedStoreId, sortField, sortOrder, store]);


    useEffect(() => {
        const handleStoreChange = () => {
            const storeId = selectedStoreId;
            setSelectedStoreId(storeId);
            setCurrentPage(1); // reset page
        };

        window.addEventListener("storeChanged", handleStoreChange);
        return () => window.removeEventListener("storeChanged", handleStoreChange);
    }, []);

    const handleUpdateSubCategory = async (e) => {
        e.preventDefault();

        setShowLoader(true);             // ✅ START LOADER

        try {
            const token = localStorage.getItem("Token");
            const userId = localStorage.getItem("userId");

            let updatedImageObject = formData.subCategoryImageObject;

            if (uploadMethod === "Normal") {
                if (subcategoryImage && userId) {
                    const uploadResult = await uploadFile(
                        `files/upload/${userId}`,
                        subcategoryImage
                    );

                    if (uploadResult?.status === 200 || uploadResult?.success) {
                        updatedImageObject = uploadResult.data;
                    } else {
                        toast.error(uploadResult?.message || "Image upload failed");
                        setShowLoader(false);
                        return;
                    }
                }
            } else {
                updatedImageObject = selectedStockImage;
            }
            const updatedSubCategoryData = {
                categoryId: formData.categoryId,
                subCategoryName: formData.subCategoryName,
                subCategoryImageObject: updatedImageObject,
                imageSource: uploadMethod === "Stock" ? "Stock" : "Upload"
            };

            console.log("Updating subcategory with data:", updatedSubCategoryData);

            const response = await putData(
                `subcategories/subcategory/${editsubCategoryId}`,
                updatedSubCategoryData,
                token
            );

            toast.success(response.message || "Sub Category updated successfully");

            // ✅ RESET FORM & UI
            setFormData({
                categoryId: "",
                subCategoryName: "",
                subCategoryImageObject: null
            });

            setsubCategoryImage(null);
            setSelectedStockImage(null);
            setPreviewUrl(null);
            setUploadMethod("Normal");
            setIsPopupMode(false);
            setIsEditMode(false);
            triggerRefresh();

        } catch (error) {
            console.error("Update SubCategory Error:", error);
            toast.error("Error updating category.");
        } finally {
            setTimeout(() => {
                setShowLoader(false);
            }, 1000);
        }
    };

    const handleDeleteSubCategory = async (e) => {
        e.preventDefault();
        try {
            const token = localStorage.getItem('Token');
            const response = await deleteData(`subcategories/subcategory/${subcategoryToDelete}`, token);
            toast.success(response.message || "subCategory deleted successfully");
            setsubCategoryToDelete(null);
            handleClose();
            triggerRefresh();
        } catch (error) {
            console.error("Delete error:", error);
            toast.error(error.message || "Failed to delete subCategory");
        }
    };

    const handleViewsubCategory = async (subCategoryId) => {
        try {
            setLoading(true);

            const sessionToken = localStorage.getItem("Token");
            if (!sessionToken) {
                toast.error("Session expired. Please log in again.");
                return;
            }

            const response = await getData(`subcategories/subcategory/${subCategoryId}`, sessionToken);

            // Depending on your webservice, check if data is nested
            const data = response?.data || response;

            if (!data) {
                toast.error("No data found for this subcategory.");
                return;
            }

            setViewsubCategoryData(data);
            setOpenViewPopup(true);
        } catch (error) {
            console.error("Error fetching subcategory:", error);
            toast.error(error.message || "Failed to fetch subcategory data");
        } finally {
            setLoading(false);
        }
    };

    const handleEditsubCategory = async (subCategoryId) => {
        try {
            setLoading(true);
            const token = localStorage.getItem("Token");
            const response = await getData(`subcategories/subcategory/${subCategoryId}`, token);
            const subcat = response?.data || response;

            const sId = subcat.storeId?._id || subcat.storeId || "";
            const sName = subcat.storeId?.storeName || stores.find(s => s._id === sId)?.storeName || "";

            setFormData({
                storeId: sId,
                storeName: sName,
                categoryId: subcat.categoryId?._id || subcat.categoryId || "",
                categoryName: subcat.categoryId?.categoryName || "",
                subCategoryName: subcat.subCategoryName || '',
                subCategoryImageObject: subcat.subCategoryImageObject || null,
                imageSource: subcat.imageSource || 'Upload'
            });

            const isStock = subcat.imageSource === "Stock";
            setUploadMethod(isStock ? "Stock" : "Normal");
            setSelectedStockImage(isStock ? subcat.subCategoryImageObject : null);
            setsubCategoryImage(null);

            const baseUrl = (process.env.REACT_APP_API_URL || "").replace(/\/+$/, "");
            const uri = subcat.subCategoryImageObject?.uri || "";
            setPreviewUrl(
                uri
                    ? `${baseUrl}/${uri.replace(/^\/+/, "")}`
                    : "/assets/placeholder.png"
            );
            setEditsubCategoryId(subcat._id);
            setIsPopupMode(true);
            setIsEditMode(true);
            setLoaderText("Updating Sub Category...");
        } catch (error) {
            console.error("Edit fetch error:", error);
            toast.error("Failed to load subcategory details.");
        } finally {
            setLoading(false);
        }
    };

    const triggerRefresh = () => {
        setRefreshKey(prev => prev + 1);
    };

    const handleOpen = (subCategoryId) => {
        setsubCategoryToDelete(subCategoryId);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setsubCategoryToDelete(null);
    };

    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const params = {
                    storeId: selectedStoreId
                }
                const token = localStorage.getItem("Token");
                const data = await getData('categories/categories', params, token);
                console.log("API Full Response: ", data);
                const results = data?.data?.results?.[0]?.paginatedResults || [];
                setCategories(results);
            } catch (error) {
                console.error("Failed to load categories", error);
            }
        };

        fetchCategories();
    }, [selectedStoreId]);

    const handlePageChange = (direction) => {
        setCurrentPage((prev) => {
            if (direction === "next") return Math.min(prev + 1, totalPages);
            if (direction === "prev") return Math.max(prev - 1, 1);
            if (direction === "first") return 1;
            if (direction === "last") return totalPages;
            return prev;
        });
    };

    const handleItemsPerPageChange = (e) => {
        const value = e.target.value;
        const newLimit = value === "all" ? "all" : Number(value);
        setLimit(newLimit);
        setCurrentPage(1);
    };

    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: '#F7EAE2',
        borderRadius: 12,
        boxShadow: 24,
        p: 4,
        border: 0
    };

    useEffect(() => {
        const fetchStores = async () => {
            try {
                const token = localStorage.getItem("Token");
                const data = await getData('stores/stores', {}, token);
                const results = data?.data?.results || [];
                setStores(results);

                // For Admin: set default storeId
                if (role === "Admin") {
                    const adminStoreIds = JSON.parse(localStorage.getItem("storeIds") || "[]");
                    if (adminStoreIds.length === 1) {
                        setFormData(prev => ({ ...prev, storeId: adminStoreIds[0] }));
                    }
                }
            } catch (error) {
                console.error("Failed to load stores", error);
            }
        };
        fetchStores();
    }, []);

    const handleRemoveImage = () => {
        setPreviewUrl(null);
        setsubCategoryImage(null);
        setSelectedStockImage(null);
    };

    const handleStockSelect = (imageObject) => {
        if (!imageObject) return;
        setSelectedStockImage(imageObject);
        const baseUrl = (process.env.REACT_APP_API_URL || "").replace(/\/+$/, "");
        const uri = imageObject.uri || imageObject.fileObject?.uri || "";
        if (uri) {
            setPreviewUrl(`${baseUrl}/${uri.replace(/^\/+/, "")}`);
        }
        setShowStockPicker(false);
        setErrors(prev => ({ ...prev, subCategoryImage: null }));
    };

    const validateFields = (data, method, subCategoryImage, stockImg) => {
        let newErrors = {};
        if (!data.storeId) newErrors.storeId = "Store is required";
        if (method === "Normal" && subCategoryImage) {
            const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
            const allowedExtensions = ["jpg", "jpeg", "png"];
            const fileExtension = subCategoryImage.name.split('.').pop().toLowerCase();
            const isValidType = allowedTypes.includes(subCategoryImage.type) || allowedExtensions.includes(fileExtension);
            if (!isValidType) {
                newErrors.subCategoryImage = "Only JPEG, JPG, and PNG images are allowed.";
            } else if (subCategoryImage.size > 1024 * 1024) {
                newErrors.subCategoryImage = "Image size exceeds 1MB. Please select an image smaller than 1MB.";
            }
        }
        if (!data.categoryId) newErrors.categories = "Category Name is required";
        if (!data.subCategoryName?.trim()) newErrors.subCategoryName = "subCategory Name is required";

        return newErrors;
    }

    const loadStores = async (inputValue, loadedOptions, { page }) => {
        try {
            const res = await getData(
                "stores/stores",
                { page, limit: 10, search: inputValue },
                sessionToken
            );

            const results = res?.data?.results || EMPTY_ARRAY;

            const options = results.map(store => ({
                value: store._id,
                label: store.storeName
            }));

            return {
                options,
                hasMore: results.length === 10,
                additional: { page: page + 1 }
            };

        } catch (err) {
            console.error("Store Fetch Failed", err);
            return { options: [], hasMore: false };
        }
    };

    return (
        <div className="product-layout">
            <div className="product-content">
                {showLoader && (
                    <div className="scissor-overlay">
                        <div className="scissor-loader">
                            <TVFMLoader />
                        </div>
                    </div>
                )}
                <main className="product-main">
                    {isAddPage ? (
                        <div className="add-category-form">
                            <Typography variant="h6" gutterBottom sx={{ mb: 2 }}>
                                Add SubCategory
                            </Typography>
                            <form className="category-form">
                                <div className="category-form-row">
                                    <div className="category-form-group">
                                        <label className="input-label">Store Name</label>
                                        <StoreMultiSelect
                                            value={
                                                formData.storeId
                                                    ? [{
                                                        value: formData.storeId,
                                                        label: formData.storeName
                                                    }]
                                                    : []
                                            }
                                            onChange={(val) => {
                                                // ❌ Prevent clearing if only one store
                                                if (adminStoreIds.length === 1) return;

                                                setFormData(prev => ({
                                                    ...prev,
                                                    storeId: val?.[0]?.value || "",
                                                    storeName: val?.[0]?.label || "",
                                                    categoryId: "",
                                                    categoryName: ""
                                                }));
                                                setCategoryRefreshKey(prev => prev + 1);
                                            }}
                                            loadStores={loadStores}
                                            loggedInRole={role}
                                            assignedStoreIds={adminStoreIds}
                                            isDisabled={adminStoreIds.length === 1}   // 🔥 KEY LINE
                                        />
                                        {errors.storeId && <p className="field-error">{errors.storeId}</p>}
                                    </div>
                                    <div className="category-form-group">
                                        <label htmlFor="categoryId" className="input-label">
                                            Category Name
                                        </label>
                                        <CategorySelect
                                            key={categoryRefreshKey}
                                            value={formData.categoryId ? { value: formData.categoryId, label: formData.categoryName || "Selected Category" } : null}
                                            onChange={(val) => {
                                                setFormData(prev => ({
                                                    ...prev,
                                                    categoryId: val?.value || "",
                                                    categoryName: val?.label || ""
                                                }));
                                            }}
                                            loadCategories={loadCategories}
                                            isMulti={false}
                                            loggedInRole={role}
                                            onAddCategory={() => setIsAddCategory(true)}
                                        />
                                        {errors.categories && <p className="field-error">{errors.categories}</p>}
                                    </div>
                                    <div className="category-form-group">
                                        <label htmlFor="subCategoryName" className="input-label">
                                            Sub-Category Name
                                        </label>
                                        <input
                                            type="text"
                                            placeholder="Enter sub-category name"
                                            required
                                            className="category-input"
                                            value={formData.subCategoryName}
                                            onChange={e =>
                                                setFormData(prev => ({ ...prev, subCategoryName: e.target.value }))
                                            }
                                        />
                                        {errors.subCategoryName && <p className="field-error">{errors.subCategoryName}</p>}
                                    </div>


                                    <div className="category-form-group" style={{ gridColumn: 'span 2' }}>
                                        <label htmlFor="categoryImage" className="input-label">
                                            SubCategory Image (Max 1MB, JPEG/JPG/PNG only)
                                        </label>
                                        <div className="upload-options" style={{ display: 'flex', gap: '20px', marginBottom: '12px' }}>
                                            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontSize: '14px', fontWeight: '500', color: '#525252' }}>
                                                <input
                                                    type="radio"
                                                    name="addUploadMethod"
                                                    checked={uploadMethod === "Normal"}
                                                    style={{ accentColor: 'linear-gradient(90deg, #181B23 0%, #1C202B 35%, #1A1E28 65%, #161A22 100%)' }}
                                                    onChange={() => {
                                                        setUploadMethod("Normal");
                                                        setPreviewUrl(subcategoryImage ? URL.createObjectURL(subcategoryImage) : null);
                                                    }}
                                                />
                                                Normal Upload
                                            </label>
                                            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontSize: '14px', fontWeight: '500', color: '#525252' }}>
                                                <input
                                                    type="radio"
                                                    name="addUploadMethod"
                                                    checked={uploadMethod === "Stock"}
                                                    style={{ accentColor: 'linear-gradient(90deg, #181B23 0%, #1C202B 35%, #1A1E28 65%, #161A22 100%)' }}
                                                    onChange={() => {
                                                        setUploadMethod("Stock");
                                                        if (selectedStockImage) {
                                                            const baseUrl = (process.env.REACT_APP_API_URL || "").replace(/\/+$/, "");
                                                            const uri = selectedStockImage.uri || selectedStockImage.fileObject?.uri || "";
                                                            setPreviewUrl(`${baseUrl}/${uri.replace(/^\/+/, "")}`);
                                                        } else {
                                                            setPreviewUrl(null);
                                                        }
                                                    }}
                                                />
                                                Stock Image
                                            </label>
                                        </div>

                                        {uploadMethod === "Normal" ? (
                                            <input
                                                type="file"
                                                accept=".jpeg,.jpg,.png"
                                                id="subCategoryImage"
                                                className="category-input"
                                                onChange={(e) => {
                                                    const file = e.target.files[0];
                                                    if (file) {
                                                        const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
                                                        const allowedExtensions = ["jpg", "jpeg", "png"];
                                                        const fileExtension = file.name.split('.').pop().toLowerCase();
                                                        const isValidType = allowedTypes.includes(file.type) || allowedExtensions.includes(fileExtension);

                                                        if (!isValidType) {
                                                            setErrors(prev => ({ ...prev, subCategoryImage: "Only JPEG, JPG, and PNG images are allowed." }));
                                                            toast.error("Only JPEG, JPG, and PNG images are allowed.");
                                                            setsubCategoryImage(null);
                                                            setPreviewUrl(null);
                                                            if (e.target) e.target.value = "";
                                                        } else if (file.size > 1024 * 1024) {
                                                            setErrors(prev => ({ ...prev, subCategoryImage: "Image size exceeds 1MB. Please select an image smaller than 1MB." }));
                                                            toast.error("Image size exceeds 1MB. Please select an image smaller than 1MB.");
                                                            setsubCategoryImage(null);
                                                            setPreviewUrl(null);
                                                            if (e.target) e.target.value = "";
                                                        } else {
                                                            setsubCategoryImage(file);
                                                            setPreviewUrl(URL.createObjectURL(file));
                                                            setErrors(prev => ({ ...prev, subCategoryImage: null }));
                                                        }
                                                    }
                                                }}
                                            />
                                        ) : (
                                            <div className="stock-picker-trigger">
                                                <button
                                                    type="button"
                                                    className="select-stock-btn"
                                                    onClick={() => setShowStockPicker(true)}
                                                    style={{
                                                        width: '100%',
                                                        padding: '8px 12px',
                                                        background: '#fff',
                                                        border: '1px solid #ccc',
                                                        borderRadius: '6px',
                                                        cursor: 'pointer',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        textAlign: 'left',
                                                        justifyContent: 'flex-start',
                                                        gap: '10px',
                                                        fontSize: '14px',
                                                        color: selectedStockImage ? '#333' : '#888'
                                                    }}
                                                >
                                                    <Icon icon="mdi:image-search" style={{ fontSize: '18px', color: '#64748b' }} />
                                                    {selectedStockImage ? `Selected: ${selectedStockImage.name || 'Stock Image'}` : "Click to select a stock image..."}
                                                </button>
                                            </div>
                                        )}
                                        {errors.subCategoryImage && <p className="field-error">{errors.subCategoryImage}</p>}
                                        {previewUrl && (
                                            <div className="image-preview" style={{ marginTop: '12px', display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                                                <div style={{ position: 'relative' }}>
                                                    <img src={previewUrl} alt="Preview" style={{ width: '80px', height: '80px', objectFit: 'cover', borderRadius: '12px', border: '1px solid #e2e8f0', boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)' }} />
                                                    <div
                                                        style={{
                                                            position: 'absolute',
                                                            top: '-8px',
                                                            right: '-8px',
                                                            background: '#ef4444',
                                                            color: 'white',
                                                            borderRadius: '50%',
                                                            width: '20px',
                                                            height: '20px',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            cursor: 'pointer',
                                                            boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                                                            zIndex: 5
                                                        }}
                                                        onClick={handleRemoveImage}
                                                        title="Remove image"
                                                    >
                                                        <Icon icon="mdi:close" style={{ fontSize: '14px' }} />
                                                    </div>
                                                </div>
                                                {uploadMethod === "Stock" && selectedStockImage && (
                                                    <div style={{ paddingTop: '4px' }}>
                                                        <p style={{ fontSize: '13px', fontWeight: '600', color: '#1e293b', margin: '0' }}>Stock Image Selected</p>
                                                        <p style={{ fontSize: '11px', color: '#64748b', margin: '2px 0 0' }}>{selectedStockImage.name}</p>
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className="category-buttons">
                                    <button className="add-Product-button" type="submit" onClick={handleAddSubCategory}>
                                        Add SubCategory
                                    </button>
                                    <button className="cancel-Product-button" onClick={() => navigate('/products/sub-category')}>
                                        Cancel
                                    </button>
                                </div>
                            </form>
                        </div>
                    ) : (
                        <>
                            <Typography variant="h6" sx={{ mb: 2 }}>
                                Sub Categories
                            </Typography>
                            <div className="product-widgets">
                                <div className="search-input-wrapper">
                                    <input
                                        type="text"
                                        placeholder="Search sub-categories..."
                                        className="subcategory-search-input"
                                        value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)}
                                    />
                                    <Icon icon="mdi:magnify" className="search-icon" />
                                </div>
                                {(role === "SuperAdmin" || role === "SelfAdmin") && (
                                    <StoreSingleAllStoresSelect
                                        value={store}
                                        onChange={
                                            (store) => {
                                                setStore(store)
                                            }
                                        }
                                    />
                                )}
                                <div className="add-product-buttons">
                                     <button
                                         className="add-btn-product"
                                         onClick={() => fileInputRef.current?.click()}
                                     >
                                         Import
                                     </button>
                                     <button
                                         className="add-btn-product"
                                         onClick={() => navigate('/products/sub-category/add')}
                                     >
                                         + Add SubCategory
                                     </button>
                                     <button
                                         className="add-btn-product"
                                         onClick={handleDownloadSampleTemplate}
                                     >
                                         Download Sample Template
                                     </button>
                                 </div>
                                 <input
                                     type="file"
                                     accept=".xlsx, .xls"
                                     style={{ display: "none" }}
                                     ref={fileInputRef}
                                     onChange={handleBulkUploadClick}
                                 />
                             </div>                  
                            <Box component={Paper}>
                                <TableContainer component={Paper} sx={{
                                    overflow: 'auto',
                                    maxHeight: '400px',
                                    '&::-webkit-scrollbar': { display: 'none' },
                                    scrollbarWidth: 'none',
                                    msOverflowStyle: 'none',

                                }}>
                                    <Table className="custom-SubCategory-table">
                                        <TableHead className="custom-product-head">
                                            <TableRow>
                                                {headings.map((heading, index) => {
                                                    const isCategoryName = heading === "Category Name";
                                                    const isSubCategoryName = heading === "SubCategory Name";
                                                    const sortKey = isCategoryName
                                                        ? "categoryId"
                                                        : isSubCategoryName
                                                            ? "subCategoryName"
                                                            : null

                                                    return (
                                                        <TableCell
                                                            key={index}
                                                            sx={{
                                                                border: "none",
                                                                padding: "12px 16px",
                                                                textAlign: "center",
                                                                position: "sticky",
                                                                top: 0,
                                                                zIndex: 10,
                                                            }}
                                                        >
                                                            <Typography
                                                                variant="body2"
                                                                sx={{
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                    gap: "4px",
                                                                    color: "#ffffff",
                                                                    fontSize: "14px",
                                                                    fontWeight: 600,
                                                                }}
                                                            >
                                                                {heading}

                                                                {sortKey && (
                                                                    <span
                                                                        onClick={() => handleSort(sortKey)}
                                                                        style={{
                                                                            fontSize: "10px",
                                                                            color: "#ffffffff",
                                                                            cursor: "pointer",
                                                                            marginLeft: "4px",
                                                                            userSelect: "none",
                                                                        }}
                                                                    >
                                                                        {sortField === sortKey
                                                                            ? sortOrder === 1
                                                                                ? "▲"
                                                                                : "▼"
                                                                            : "▲▼"}
                                                                    </span>
                                                                )}
                                                            </Typography>
                                                        </TableCell>
                                                    );
                                                })}
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {subcategories.length === 0 ? (
                                                <TableRow>
                                                    <TableCell colSpan={5}>
                                                        <Typography sx={{ textAlign: 'center', padding: '20px', fontWeight: 500 }}>
                                                            No subCategories found.
                                                        </Typography>
                                                    </TableCell>
                                                </TableRow>
                                            ) : (
                                                subcategories.map((subcat, index) => (
                                                    <TableRow key={subcat._id}>
                                                        <TableCell>
                                                            <Typography sx={commonCellStyle}>
                                                                {(currentPage - 1) * (limit === 'all' ? 0 : limit) + index + 1}
                                                            </Typography>
                                                        </TableCell>
                                                        <TableCell>
                                                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                                <img
                                                                    src={subcat?.subCategoryImageObject?.uri ? `${process.env.REACT_APP_API_URL}${subcat.subCategoryImageObject.uri}` : "/assets/placeholder.png"}
                                                                    alt={subcat.subCategoryName || subcat.name}
                                                                    onError={(e) => { e.target.onerror = null; e.target.src = "/assets/placeholder.png"; }}
                                                                    style={{ width: '50px', height: '50px', borderRadius: '8px', objectFit: 'cover' }}
                                                                />
                                                            </Box>
                                                        </TableCell>
                                                        <TableCell>
                                                            <Typography sx={commonCellStyle}>{subcat.categoryDetails?.[0]?.categoryName}</Typography>
                                                        </TableCell>
                                                        <TableCell>
                                                            <Typography sx={commonCellStyle}>{subcat.name || subcat.subCategoryName}</Typography>
                                                        </TableCell>
                                                        <TableCell>
                                                            <Box sx={{ display: 'flex', gap: 3, alignItems: 'center', justifyContent: 'center' }}>
                                                                <Tooltip title="View Product Sub-Category">
                                                                    <Icon icon={plusIcon} width={20} height={20} style={{ cursor: 'pointer' }} onClick={() => handleViewsubCategory(subcat._id)} />
                                                                </Tooltip>
                                                                <Tooltip title="Edit Product Sub-Category">
                                                                    <Icon icon={editIcon} width={20} height={20} style={{ cursor: "pointer" }} onClick={() => handleEditsubCategory(subcat._id)} />
                                                                </Tooltip>
                                                                {role !== "SelfAdmin" && (
                                                                    <Tooltip title="Delete Product Sub-Category">
                                                                        <Icon icon={deleteIcon} width={20} height={20} style={{ color: '#C10000', cursor: 'pointer' }}
                                                                            onClick={() => handleOpen(subcat._id)}
                                                                        />
                                                                    </Tooltip>
                                                                )}
                                                            </Box>
                                                        </TableCell>
                                                    </TableRow>
                                                ))
                                            )}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                <div className="product-bottom">
                                    <div className="product-section show-entries">
                                        <span className="text-label">Show</span>
                                        <select className="entries-select" value={limit}
                                            onChange={handleItemsPerPageChange}
                                        >
                                            <option value="5">5</option>
                                            <option value="10">10</option>
                                            <option value="25">25</option>
                                            <option value="all">All</option>
                                        </select>
                                        <span className="text-label">Entries</span>
                                    </div>
                                    <div className="product-section showing-range">
                                        {
                                            limit === 'all'
                                                ? `Showing all ${totalCount} entries`
                                                : `Showing ${(currentPage - 1) * limit + 1} to ${Math.min(currentPage * limit, totalCount)} of ${totalCount} entries`
                                        }
                                    </div>
                                    <div className="product-section spacer"></div>
                                    <div className="product-section pagination-buttons">
                                        <button
                                            className="pagination-btn"
                                            disabled={currentPage === 1}
                                            onClick={() => handlePageChange("first")}
                                        ><Icon icon="mdi:chevron-double-left" /></button>
                                        <button
                                            className="pagination-btn"
                                            disabled={currentPage === 1}
                                            onClick={() => handlePageChange("prev")}
                                        ><Icon icon="mdi:chevron-left" /></button>
                                        <button
                                            className="pagination-btn"
                                            disabled={currentPage === totalPages}
                                            onClick={() => handlePageChange("next")}
                                        ><Icon icon="mdi:chevron-right" /></button>
                                        <button
                                            className="pagination-btn"
                                            disabled={currentPage === totalPages}
                                            onClick={() => handlePageChange("last")}
                                        ><Icon icon="mdi:chevron-double-right" /></button>
                                    </div>
                                </div>
                            </Box>
                            {isPopupMode && (
                                <div className="popup-overlay">
                                    <div className="popup-wrapper">
                                        <Icon
                                            icon={closeIcon}
                                            className="popup-close-icon-outside"
                                            onClick={() => {
                                                setIsPopupMode(false);
                                                setIsEditMode(false);
                                                setFormData({ categoryName: '' });
                                                setPreviewUrl(null);
                                                setLoaderText("");
                                            }}
                                        />

                                        <div className="popup-form">
                                            <Typography variant="h6" className="popup-title" mb={4}>
                                                {isEditMode ? "Edit Sub Category" : "Add SubCategory"}
                                            </Typography>
                                            <form className="popup-form-body" onSubmit={handleUpdateSubCategory}>
                                                <div className="form-group-row">
                                                    <div className="form-group">
                                                        <label className="input-label">Store Name</label>
                                                        <StoreMultiSelect
                                                            value={
                                                                formData.storeId
                                                                    ? (Array.isArray(formData.storeId)
                                                                        ? formData.storeId.map((id, i) => ({
                                                                            value: id,
                                                                            label: Array.isArray(formData.storeName) ? formData.storeName[i] : formData.storeName
                                                                        }))
                                                                        : [{ value: formData.storeId, label: formData.storeName }]
                                                                    )
                                                                    : []
                                                            }
                                                            onChange={(val) => {
                                                                const storeId = val && val.length > 0 ? val[0].value : "";
                                                                const storeName = val && val.length > 0 ? val[0].label : "";
                                                                setFormData(prev => ({
                                                                    ...prev,
                                                                    storeId: storeId,
                                                                    storeName: storeName,
                                                                    categoryId: "",
                                                                    categoryName: ""
                                                                }));
                                                                setCategoryRefreshKey(prev => prev + 1);
                                                                setErrors(prev => ({ ...prev, storeId: null }));
                                                            }}
                                                            loadStores={loadStores}
                                                            loggedInRole={role}
                                                            assignedStoreIds={adminStoreIds}
                                                            onAddStore={() => setIsAddStore(true)}
                                                            isMulti={false}
                                                        />
                                                        {errors.storeId && <p className="field-error">{errors.storeId}</p>}
                                                    </div>
                                                    <div className="form-group">
                                                        <label htmlFor="CategoryName">Category Name</label>
                                                        <CategorySelect
                                                            key={`${formData.storeId}-${categoryRefreshKey}`}
                                                            value={formData.categoryId ? { value: formData.categoryId, label: formData.categoryName || "Selected Category" } : null}
                                                            onChange={(val) => {
                                                                setFormData(prev => ({
                                                                    ...prev,
                                                                    categoryId: val?.value || "",
                                                                    categoryName: val?.label || ""
                                                                }));
                                                                setErrors(prev => ({ ...prev, categories: null }));
                                                            }}
                                                            loadCategories={loadCategories}
                                                            isMulti={false}
                                                            loggedInRole={role}
                                                            onAddCategory={() => setIsAddCategory(true)}
                                                        />
                                                        {errors.categories && <p className="field-error">{errors.categories}</p>}
                                                    </div>
                                                    <div className="form-group">
                                                        <label htmlFor="subCategoryName">Sub Category Name</label>
                                                        <input
                                                            type="text"
                                                            id="subCategoryName"
                                                            placeholder="Enter subcategory name"
                                                            value={formData.subCategoryName}
                                                            onChange={(e) => {
                                                                setFormData((prev) => ({
                                                                    ...prev,
                                                                    subCategoryName: e.target.value,
                                                                }));
                                                                setErrors(prev => ({ ...prev, subCategoryName: null }));
                                                            }}
                                                        />
                                                        {errors.subCategoryName && <p className="field-error">{errors.subCategoryName}</p>}
                                                    </div>
                                                </div>
                                                <div className="form-group-row">

                                                    <div className="form-group" style={{ gridColumn: 'span 2' }}>
                                                        <label htmlFor="subcategoryImage">SubCategory Image (Max 1MB, JPEG/JPG/PNG only)</label>
                                                        <div className="upload-options" style={{ display: 'flex', gap: '20px', marginBottom: '12px' }}>
                                                            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontSize: '14px', fontWeight: '500', color: '#525252' }}>
                                                                <input
                                                                    type="radio"
                                                                    name="editUploadMethod"
                                                                    checked={uploadMethod === "Normal"}
                                                                    style={{ accentColor: 'linear-gradient(90deg, #181B23 0%, #1C202B 35%, #1A1E28 65%, #161A22 100%)' }}
                                                                    onChange={() => {
                                                                        setUploadMethod("Normal");
                                                                        setPreviewUrl(subcategoryImage ? URL.createObjectURL(subcategoryImage) : (formData.subCategoryImageObject?.uri ? `${process.env.REACT_APP_API_URL}${formData.subCategoryImageObject.uri}` : null));
                                                                    }}
                                                                />
                                                                Normal Upload
                                                            </label>
                                                            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontSize: '14px', fontWeight: '500', color: '#525252' }}>
                                                                <input
                                                                    type="radio"
                                                                    name="editUploadMethod"
                                                                    checked={uploadMethod === "Stock"}
                                                                    style={{ accentColor: 'linear-gradient(90deg, #181B23 0%, #1C202B 35%, #1A1E28 65%, #161A22 100%)' }}
                                                                    onChange={() => {
                                                                        setUploadMethod("Stock");
                                                                        if (selectedStockImage) {
                                                                            const baseUrl = (process.env.REACT_APP_API_URL || "").replace(/\/+$/, "");
                                                                            const uri = selectedStockImage.uri || selectedStockImage.fileObject?.uri || "";
                                                                            setPreviewUrl(`${baseUrl}/${uri.replace(/^\/+/, "")}`);
                                                                        } else {
                                                                            const isOriginalStock = formData.imageSource === "Stock";
                                                                            const stockImg = isOriginalStock ? formData.subCategoryImageObject : null;
                                                                            if (stockImg) {
                                                                                const baseUrl = (process.env.REACT_APP_API_URL || "").replace(/\/+$/, "");
                                                                                const uri = stockImg.uri || "";
                                                                                setPreviewUrl(`${baseUrl}/${uri.replace(/^\/+/, "")}`);
                                                                            } else {
                                                                                setPreviewUrl(null);
                                                                            }
                                                                        }
                                                                    }}
                                                                />
                                                                Stock Image
                                                            </label>
                                                        </div>

                                                        {uploadMethod === "Normal" ? (
                                                            <input
                                                                type="file"
                                                                id="subSubcategoryImage"
                                                                accept=".jpeg,.jpg,.png"
                                                                style={{ padding: '8px 12px', border: '1px solid #ccc', borderRadius: '6px', width: '100%' }}
                                                                onChange={(e) => {
                                                                    const file = e.target.files[0];
                                                                    if (file) {
                                                                        const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
                                                                        const allowedExtensions = ["jpg", "jpeg", "png"];
                                                                        const fileExtension = file.name.split('.').pop().toLowerCase();
                                                                        const isValidType = allowedTypes.includes(file.type) || allowedExtensions.includes(fileExtension);

                                                                        if (!isValidType) {
                                                                            setErrors(prev => ({ ...prev, subCategoryImage: "Only JPEG, JPG, and PNG images are allowed." }));
                                                                            toast.error("Only JPEG, JPG, and PNG images are allowed.");
                                                                            setsubCategoryImage(null);
                                                                            setPreviewUrl(null);
                                                                            if (e.target) e.target.value = "";
                                                                        } else if (file.size > 1024 * 1024) {
                                                                            setErrors(prev => ({ ...prev, subCategoryImage: "Image size exceeds 1MB. Please select an image smaller than 1MB." }));
                                                                            toast.error("Image size exceeds 1MB. Please select an image smaller than 1MB.");
                                                                            setsubCategoryImage(null);
                                                                            setPreviewUrl(null);
                                                                            if (e.target) e.target.value = "";
                                                                        } else {
                                                                            setsubCategoryImage(file);
                                                                            setPreviewUrl(URL.createObjectURL(file));
                                                                            setErrors(prev => ({ ...prev, subCategoryImage: null }));
                                                                        }
                                                                    }
                                                                }}
                                                            />
                                                        ) : (
                                                            <div className="stock-picker-trigger">
                                                                <button
                                                                    type="button"
                                                                    className="select-stock-btn"
                                                                    onClick={() => setShowStockPicker(true)}
                                                                    style={{
                                                                        width: '100%',
                                                                        padding: '8px 12px',
                                                                        background: '#fff',
                                                                        border: '1px solid #ccc',
                                                                        borderRadius: '6px',
                                                                        cursor: 'pointer',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        textAlign: 'left',
                                                                        justifyContent: 'flex-start',
                                                                        gap: '10px',
                                                                        fontSize: '14px',
                                                                        color: selectedStockImage ? '#333' : '#888'
                                                                    }}
                                                                >
                                                                    <Icon icon="mdi:image-search" style={{ fontSize: '18px', color: '#64748b' }} />
                                                                    {selectedStockImage ? `Selected: ${selectedStockImage.name || 'Stock Image'}` : "Click to select a stock image..."}
                                                                </button>
                                                            </div>
                                                        )}
                                                        {errors.subCategoryImage && <p className="field-error">{errors.subCategoryImage}</p>}
                                                        {previewUrl && (
                                                            <div className="image-preview" style={{ marginTop: '12px', display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                                                                <div style={{ position: 'relative' }}>
                                                                    <img src={previewUrl} alt="Preview" style={{ width: '80px', height: '80px', objectFit: 'cover', borderRadius: '12px', border: '1px solid #e2e8f0', boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)' }} />
                                                                    <div
                                                                        style={{
                                                                            position: 'absolute',
                                                                            top: '-8px',
                                                                            right: '-8px',
                                                                            background: '#ef4444',
                                                                            color: 'white',
                                                                            borderRadius: '50%',
                                                                            width: '20px',
                                                                            height: '20px',
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            justifyContent: 'center',
                                                                            cursor: 'pointer',
                                                                            boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                                                                            zIndex: 5
                                                                        }}
                                                                        onClick={handleRemoveImage}
                                                                        title="Remove image"
                                                                    >
                                                                        <Icon icon="mdi:close" style={{ fontSize: '14px' }} />
                                                                    </div>
                                                                </div>
                                                                {uploadMethod === "Stock" && selectedStockImage && (
                                                                    <div style={{ paddingTop: '4px' }}>
                                                                        <p style={{ fontSize: '13px', fontWeight: '600', color: '#1e293b', margin: '0' }}>Stock Image Selected</p>
                                                                        <p style={{ fontSize: '11px', color: '#64748b', margin: '2px 0 0' }}>{selectedStockImage.name}</p>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>

                                                <div className="form-actions">
                                                    <button type="submit" className="add-Product-button">
                                                        {isEditMode ? "Update Sub Category" : "Add Sub Category"}
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="cancel-Product-button"
                                                        onClick={() => setIsPopupMode(false)}
                                                    >
                                                        Cancel
                                                    </button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            )}
                            <Modal
                                open={open}
                                onClose={handleClose}
                                aria-labelledby="modal-modal-title"
                            >
                                <Box
                                    sx={{
                                        position: "absolute",
                                        top: "50%",
                                        left: "50%",
                                        transform: "translate(-50%, -50%)",
                                        width: 380,
                                        background: "linear-gradient(135deg, #ffffff, #faf5f6)",
                                        borderRadius: "20px",
                                        boxShadow: "0 25px 70px rgba(0,0,0,0.35)",
                                        p: 4,
                                        outline: "none",
                                        textAlign: "center",
                                        overflow: "hidden"
                                    }}
                                >
                                    {/* ✅ TOP ICON BADGE */}
                                    <Box
                                        sx={{
                                            width: 74,
                                            height: 74,
                                            borderRadius: "50%",
                                            background: "#3C0008",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            margin: "0 auto 16px auto",
                                            color: "#fff",
                                            fontSize: 30,

                                            boxShadow: "0 12px 28px rgba(26,30,39,0.55)",
                                            animation: "deletePulse 1.6s infinite ease-in-out",

                                            "@keyframes deletePulse": {
                                                "0%": {
                                                    transform: "scale(1)",
                                                    boxShadow: "0 0 0 0 rgba(26,30,39,0.7)",
                                                },
                                                "70%": {
                                                    transform: "scale(1.1)",
                                                    boxShadow: "0 0 0 18px rgba(26,30,39,0)",
                                                },
                                                "100%": {
                                                    transform: "scale(1)",
                                                    boxShadow: "0 0 0 0 rgba(26,30,39,0)",
                                                },
                                            },
                                        }}
                                    >
                                        🗑️
                                    </Box>


                                    {/* ✅ TITLE */}
                                    <Typography
                                        id="modal-modal-title"
                                        variant="h6"
                                        sx={{
                                            fontWeight: 700,
                                            color: "#2b2b2b",
                                            letterSpacing: "0.3px"
                                        }}
                                    >
                                        Confirm Delete
                                    </Typography>

                                    {/* ✅ DESCRIPTION */}
                                    <Typography
                                        id="modal-modal-description"
                                        sx={{
                                            mt: 1.2,
                                            fontSize: 14,
                                            color: "#666",
                                            lineHeight: 1.6
                                        }}
                                    >
                                        Are you sure you want to delete this subCategory?
                                    </Typography>

                                    {/* ✅ BUTTON GROUP */}
                                    <Box
                                        sx={{
                                            display: "flex",
                                            justifyContent: "center",
                                            gap: 2.5,
                                            mt: 3.5
                                        }}
                                    >
                                        {/* ✅ DELETE BUTTON */}
                                        <Button
                                            variant="contained"
                                            onClick={handleDeleteSubCategory}
                                            className="add-Product-button"
                                        >
                                            Yes, Delete
                                        </Button>

                                        {/* ✅ CANCEL BUTTON */}
                                        <Button
                                            variant="outlined"
                                            onClick={handleClose}
                                            className="cancel-Product-button"
                                        >
                                            Cancel
                                        </Button>
                                    </Box>
                                </Box>
                            </Modal>
                            {openViewPopup && (
                                <ViewsubCategoryPopup
                                    data={viewsubCategoryData}
                                    onClose={() => setOpenViewPopup(false)}
                                />
                            )}
                        </>
                    )}
                    {isAddStore && (
                        <div className="popup-overlay">
                            <div className="popup-wrapper" style={{ maxWidth: '900px', width: '95%' }}>
                                <Icon
                                    icon={closeIcon}
                                    className="popup-close-icon-outside"
                                    onClick={() => setIsAddStore(false)}
                                />
                                <div className="popup-form" style={{ maxHeight: '85vh', overflowY: 'auto', padding: '20px' }}>
                                    <AddStoreForm
                                        onSuccess={() => {
                                            setIsAddStore(false);
                                            // Trigger store reload/refresh if needed
                                            // For now just close, user can re-search
                                        }}
                                        onCancel={() => setIsAddStore(false)}
                                    />
                                </div>
                            </div>
                        </div>
                    )}
                    {isAddCategory && (
                        <div className="popup-overlay">
                            <div className="popup-wrapper" style={{ maxWidth: '900px', width: '95%' }}>
                                <Icon
                                    icon={closeIcon}
                                    className="popup-close-icon-outside"
                                    onClick={() => setIsAddCategory(false)}
                                />
                                <div className="popup-form" style={{ maxHeight: '85vh', overflowY: 'auto', padding: '20px' }}>
                                    <AddCategoryForm
                                        onSuccess={(newCat) => {
                                            setIsAddCategory(false);
                                            if (newCat) {
                                                const newId = newCat._id || newCat.id;
                                                const newName = newCat.categoryName || newCat.Name || "New Category";
                                                setFormData(prev => ({
                                                    ...prev,
                                                    categoryId: newId,
                                                    categoryName: newName
                                                }));
                                            }
                                            setCategoryRefreshKey(prev => prev + 1);
                                        }}
                                        onCancel={() => setIsAddCategory(false)}
                                        initialStoreId={formData.storeId}
                                    />
                                </div>
                            </div>
                        </div>
                    )}
                    {showStockPicker && (
                        <StockImagePicker
                            onSelect={handleStockSelect}
                            onCancel={() => setShowStockPicker(false)}
                        />
                    )}
                </main>
                <Footer />
            </div>
        </div>

    );
};

export default SubCategoryPage;